export default __webpack_public_path__ + "static/media/icon-menu.cab02cf3.svg";